// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cs-selected-check-box {
  width: 16px;
  min-width: 16px;
  height: 16px;
  background-color: #d3d9e6;
  border-radius: 50%;
}
.cs-selected-check-box.cs-selected-check-box-checked {
  position: relative;
  background-color: #7faefe;
}
.cs-selected-check-box.cs-selected-check-box-checked:after {
  position: absolute;
  content: "✓";
  left: 50%;
  top: 50%;
  transform: translate(-53%, -50%);
  color: white;
  font-size: 9px;
  font-weight: bolder;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
